import TimeScrroll from '../children/TimeScrroll'
import { GetProductPrePurchaseRemindList } from '@/api/detailPage'
import Utils from '@/utils/base'
import setRemind from '@/mixins/setRemind'
import TimeNodeDialog from '@/components/smartComponent/TimeNodeDialog'
import RemindList from '../children/RemindList.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  mixins: [setRemind],
  components: {
    TimeScrroll,
    TimeNodeDialog,
    RemindList
  },
  computed: {
    ...mapGetters(['getIsApp', 'getIfShowAppDownloadGuide'])
  },
  data() {
    return {
      active: 0,
      PrePerchaseTimeToBeRemindedCount: 0,
      getProductPremangeRemindListParams: {
        dateTime: 'ALL', // 时间（传"2023-11-10 20:00:00" 其余后端处理）
        rows: 10,
        page: 1,
        loading: true,
        finished: false,
        error: false,
        list: []
      },
      timeList: [], // 时间节点
      currentTimeIndex: 0,
      isShowTimeNodeDialogOfApp: false
    }
  },
  methods: {
    ...mapMutations(['SET_GUIDE_TO_APP_POPUP_INFO']),
    changeTab() {
      this.isAppReFetchPage()
    },
    // 获取提醒列表商品接口
    async getProductPrePurchaseRemindList() {
      const currentObj = this.getProductPremangeRemindListParams
      try {
        if (currentObj.finished) return
        currentObj.loading = true
        const { dateTime, page } = this.getProductPremangeRemindListParams
        let { BuyerReserveCount, BuyerReserveTimeNode, FavoriteTotalCount, ProductRemindList } = (await GetProductPrePurchaseRemindList({ dateTime, page })).Data
        this.favoriteTotalCount = FavoriteTotalCount
        this.PrePerchaseTimeToBeRemindedCount = BuyerReserveCount
        let { rows, total } = ProductRemindList
        if (!rows) {
          rows = []
        }
        if (!BuyerReserveTimeNode) {
          BuyerReserveTimeNode = []
        }
        this.timeList = [{ Node: 'ALL' }, ...BuyerReserveTimeNode]
        currentObj.list = [...currentObj.list, ...rows]
        if (rows.length >= total) {
          currentObj.finished = true
        }
        currentObj.page++
      } catch (error) {
      } finally {
        currentObj.loading = false
      }
    },
    isAppReFetchPage() {
      this.isNewcomer = Utils.getNewcomerStorage()
      this.dataList = []
      this.dataList.splice(0)
      this.invalidDataList = []
      this.invalidDataList.splice(0)
      this.pageScrollTop = 0
      this.isReturn = false
      this.currentTab = 1
      this.hasStock = true

      this.$nextTick(() => {
        if (this.$refs.timeScroll && this.$refs.timeScroll.bsScroll) this.$refs.timeScroll.bsScroll.scrollTo(0, 0, 200)
      })

      this.getProductPremangeRemindListParams = {
        dateTime: 'ALL', // 时间（传"2023-11-10 20:00:00" 其余后端处理）
        rows: 10,
        page: 1,
        loading: true,
        finished: false,
        error: false,
        list: []
      }

      this.currentTimeIndex = 0

      if (this.active === 0) {
        this.fetchData()
      } else {
        this.getProductPrePurchaseRemindList()
      }
    },
    remindBtnHandler({ index, item }) {
      // 是否展现预约提醒引导下载APP配置 start
      const IsPrePurchase = item.ScareBuyNodeList.find((subItem) => subItem.IsPrePurchase === true)
      if (this.getIfShowAppDownloadGuide && !this.getIsApp) {
        let title = IsPrePurchase ? '该功能为APP限定功能' : '前往下载APP'
        let desc = IsPrePurchase ? '请前往APP继续操作取消预约' : '由于公众号通知权限预约提醒功能在APP才能使用哦~'
        let isLinkToApp = IsPrePurchase ? false : true
        this.SET_GUIDE_TO_APP_POPUP_INFO({
          isShow: true,
          title,
          desc,
          isLinkToApp
        })
        return
      }
      // 是否展现预约提醒引导下载APP配置 start
      this.optIdx = index
      if (this.active === 0) {
        const { ScareBuyNodeList } = item
        this.currentNodeData = ScareBuyNodeList
        this.isShowTimeNodeDialogOfApp = true
      } else {
        const { ScareBuyNodeList } = item
        this.currentNodeData = ScareBuyNodeList
        this.isShowTimeNodeDialogOfApp = true
      }
    },
    timeNodeDialogConfirmHandler(remindTimeOriginal) {
      let ProductId, ScareBuyNodeList
      let currentObj = null
      if (this.active === 0) {
        currentObj = this.dataList[this.optIdx]
        ProductId = currentObj.ProductId
      } else {
        currentObj = this.getProductPremangeRemindListParams.list[this.optIdx]
        ProductId = currentObj.ProductID
      }
      ScareBuyNodeList = currentObj.ScareBuyNodeList
      // const { ProductID, ScareBuyNodeList } = this.productInfo
      this.timeNodeHandler({ productId: ProductId, remindTimeOriginal, timeOriginal: ScareBuyNodeList })
    },
    setRemindResSucessHandler() {
      // let currentObj = null
      // let currentList = null
      // if (this.active === 0) {
      //   currentList = this.dataList
      //   currentObj = currentList[this.optIdx]
      // } else {
      //   currentList = this.getProductPremangeRemindListParams.list
      //   currentObj = currentList[this.optIdx]
      // }
      // // 假如操作影响到当前节点处理
      // const currentTimeNode = this.timeList[this.currentTimeIndex]
      // const res1 = this.remindTimeOriginal.findIndex((remindTimeOriginalVal) => {
      //   return remindTimeOriginalVal.Node === currentTimeNode.Node
      // })
      // if (res1 < 0) {
      //   if (currentList.length === 1) {
      //     // 情况一：假如数组只有一个则跳转回全部
      //     this.isAppReFetchPage()
      //     this.isShowTimeNodeDialogOfApp = false
      //   } else {
      //     // 情况二：假如数组不止一个则刷新
      //   }
      //   return
      // }
      // currentObj.ScareBuyNodeList.forEach((ScareBuyNodeListVal) => {
      //   if (
      //     this.remindTimeOriginal.findIndex((remindTimeOriginal) => {
      //       return JSON.stringify(remindTimeOriginal) === JSON.stringify(ScareBuyNodeListVal)
      //     }) > -1
      //   ) {
      //     ScareBuyNodeListVal.IsPrePurchase = true
      //   } else {
      //     ScareBuyNodeListVal.IsPrePurchase = false
      //   }
      // })
      this.isAppReFetchPage()
      this.isShowTimeNodeDialogOfApp = false
    },
    timeScrollClick(index) {
      if (this.currentTimeIndex === index) return
      this.currentTimeIndex = index
      const currentTimeListItem = this.timeList[index]
      let dateTime = 'ALL'
      if (currentTimeListItem.Node !== 'ALL') {
        dateTime = this.modifyTime(currentTimeListItem)
      }
      this.getProductPremangeRemindListParams = {
        dateTime, // 时间（传"2023-11-10 20:00:00" 其余后端处理）
        rows: 10,
        page: 1,
        loading: true,
        finished: false,
        error: false,
        list: []
      }
      this.getProductPrePurchaseRemindList()
    }
  }
}
